<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail JALA Farms",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_farms.singular')) }},
    resourceRoute: {default: 'jala_farms'},
    modelVariable: {default: 'jala_farm'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_farms.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_farms.plural')),
          href: "/jala_farms",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/jala_farms/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.name`)),
        value: this.model.name
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.country`)),
        value: (this.model.country || {}).name,
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.region`)),
        value: (this.model.region || {}).full_name,
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.address`)),
        item: this.model.address,
        value: {
          props: ['item'],
          template: `<span style="white-space: pre">{{ item || '-' }}</span>`
        }
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.latitude`)),
        value: this.model.latitude || '-',
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.longitude`)),
        value: this.model.longitude || '-',
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.timezone`)),
        value: this.model.timezone,
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.currency`)),
        value: `(${(this.model.currency || {}).id}) ${(this.model.currency || {}).name}`,
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.remark`)),
        item: this.model.remark,
        value: {
          props: { item: {type: String, default: ''} },
          template: `<span v-html="item || '-'"></span>`
        }
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/jala/farms/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/jala/farms/${this.$route.params.key}`, {
        params: { with: 'country,region,currency' }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
